var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pt-4 text-center"},[_c('b-spinner',{attrs:{"variant":"secondary","small":""}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }